import { RegionTypes } from '@app/Types/Region';

export function generateMetaTitlePage(typeRegion: RegionTypes, nameShop: string): string {
  switch (typeRegion) {
    case RegionTypes.Branch:
      return `Купить шины, услуги шиномонтажа ${nameShop} – шинный центр Колесо.ру`;
    case RegionTypes.DeliveryRegions:
      return `Купить шины ${nameShop}`;
    default:
      return `Купить шины, услуги шиномонтажа ${nameShop}`;
  }
}
